import { Navigate } from "react-router-dom";
import type { ReactNode } from "react";
import { getClientToken } from "../../api/clientPortal";

export function RequireClientAuth({ children }: { children: ReactNode }) {
  if (!getClientToken()) return <Navigate to="/portal/login" replace />;
  return <>{children}</>;
}
